/**
 * Checks if a string is a valid URL with http or https protocol.
 * @param {string} str
 * @returns {boolean}
 */
export function isValidUrl(str) {
	try {
		const url = new URL(str);
		return url.protocol === "http:" || url.protocol === "https:";
	} catch (e) {
		return false;
	}
}

export function searchParamsToObject(searchParams) {
	let obj = {};
	for (const [key, value] of searchParams.entries()) {
		obj[key] = value;
	}
	return obj;
}